import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import axiosPlugin from '@/lib/axios'

function decodeJwt(token: string) {
  try {
    const payloadBase64 = token.split('.')[1]
    const payloadJson = atob(payloadBase64)
    return JSON.parse(payloadJson)
  } catch {
    return null
  }
}

export function useAuthentication() {
  return {
    async beforeEnter(
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext,
    ) {
      try {
        const token = localStorage.getItem('access_token')
        if (!token) {
          return next({ name: 'login' })
        }

        const payload = decodeJwt(token)
        if (!payload) {
          return next({ name: 'login' })
        }

        // Check token expiration (exp is in seconds since epoch)
        const now = Math.floor(Date.now() / 1000)
        if (payload.exp && payload.exp < now) {
          return next({ name: 'login' })
        }

        // Set auth header for axios
        axiosPlugin.defaults.headers.common.Authorization = `Bearer ${token}`

        // Extract user roles from token
        const requiredRole = to.meta.requiresRole
        const userType = payload.tipo

        // Se la route richiede admin ma l'utente è cliente, redirect alla dashboard cliente
        if (requiredRole === 'admin' && userType === 'cliente') {
          return next({ name: 'cliente-dashboard' })
        }

        // Se la route richiede cliente ma l'utente è admin, redirect alla dashboard admin
        if (requiredRole === 'cliente' && userType === 'admin') {
          return next({ name: 'dashboard' })
        }

        // Verifica che l'utente abbia il ruolo richiesto
        if (requiredRole === 'admin' && userType !== 'admin') {
          return next({ name: 'login' })
        }

        if (requiredRole === 'cliente' && userType !== 'cliente') {
          return next({ name: 'login' })
        }

        next()
      } catch (err) {
        console.error('Authentication error:', err)
        next({ name: 'login' })
      }
    },
  }
}
